import type { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';

import { GlobalStyle } from './config/theme';

const Wrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 100vw;
`;

export type AppProps = {
  children: ReactNode;
};

export const App: FunctionComponent<AppProps> = ({ children }) => (
  <>
    <GlobalStyle />
    <Wrapper>{children}</Wrapper>
  </>
);
